import { render, staticRenderFns } from "./CdcByBa.vue?vue&type=template&id=374dc134&"
import script from "./CdcByBa.vue?vue&type=script&lang=js&"
export * from "./CdcByBa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports